<template>
  <Modal
    :modal-style="[{ width: '410px' }]"
    :title="$t('modals.select_twitter_trends_modal.title')"
  >
    <QSpinner
      v-if="loading"
      class="full-width q-mt-smd"
      :size="30"
    />
    <div
      key="form"
      class="q-pa-xs scroll column"
      :class="{ 'q-pa-md': $isDesktop }"
    >
      <div
        v-if="error"
        class="q-mb-md row justify-center"
      >
        {{ $t("modals.select_twitter_trends_modal.load_error") }}
      </div>
      <div v-else>
        <Checkbox
          v-for="trend in trends"
          :key="trend.name"
          :label="trend.name"
          new-design
          @update:model-value="toggleTrend(trend)"
        />
      </div>
    </div>

    <template #buttons>
      <BaseButton
        :disable="disableButton"
        :label="$t('global.cancel')"
        new-design
        @click.prevent="close"
      />
      <BaseButton
        color="primary"
        :disable="disableButton"
        :label="$t('global.insert')"
        new-design
        @click="insertTrends"
      />
    </template>
  </Modal>
</template>

<script>
import { BaseButton } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";

export default {
  name: "SelectTwitterTrendsModal",
  components: {
    Modal,
    BaseButton,
  },
  emits: ["build"],
  data() {
    return {
      loading: false,
      error: false,
      trends: [],
      selectedTrends: [],
    };
  },
  computed: {
    disableButton() {
      return this.loading || !this.selectedTrends.length;
    },
  },
  async mounted() {
    await this.getTwitterTrends();
  },
  methods: {
    async getTwitterTrends() {
      try {
        this.loading = true;
        this.trends = (await this.$streemApiV1.get("twitter/trends")).data;
      } catch {
        this.error = true;
      } finally {
        this.loading = false;
      }
    },
    insertTrends() {
      this.$emit("build", this.selectedTrends);
      this.close();
    },
    close() {
      this.$modals.close("SelectTwitterTrendsModal");
    },
    toggleTrend(val) {
      const index = this.selectedTrends.findIndex(
        ({ name }) => name === val.name
      );

      if (index < 0) {
        this.addTrend(val);
      } else {
        this.removeTrend(index);
      }
    },
    addTrend(val) {
      this.selectedTrends.push(val);
    },
    removeTrend(index) {
      this.selectedTrends.splice(index, 1);
    },
  },
};
</script>
